var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    stroke: "currentColor",
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M19.4539 15.7885L19.9397 18.7044L17.0225 18.2187C16.2237 18.6864 15.3377 18.986 14.419 19.0992C13.5003 19.2124 12.5681 19.1367 11.6796 18.8769C10.7912 18.6171 9.96511 18.1786 9.25211 17.5882C8.53911 16.9978 7.95419 16.2681 7.5332 15.4437C11.2304 15.3785 14.2085 12.3614 14.2085 8.64906C14.21 7.57573 13.9562 6.51742 13.468 5.56152C13.5086 5.56152 13.5492 5.56152 13.5911 5.56152C17.344 5.56152 20.3869 8.60384 20.3869 12.3574C20.3876 13.5638 20.0655 14.7485 19.4539 15.7885Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M16.8015 12.3535H13.1479",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M16.8016 15.0566H10.3792",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M16.8019 9.65234H14.1948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M14.2069 8.64643C14.2069 12.3587 11.2304 15.3758 7.53321 15.441C7.49261 15.441 7.452 15.441 7.41016 15.441C6.203 15.4429 5.01734 15.1216 3.97625 14.5105L1.06036 14.9972L1.54578 12.0803C0.934768 11.0392 0.613477 9.85359 0.615242 8.64643C0.615242 4.89352 3.65787 1.85059 7.41109 1.85059C8.30367 1.8501 9.18759 2.02555 10.0123 2.3669C10.837 2.70825 11.5864 3.20881 12.2176 3.83996C12.8487 4.47111 13.3493 5.22047 13.6906 6.0452C14.032 6.86993 14.2074 7.75385 14.2069 8.64643Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M5.86304 6.71522C5.86298 6.40906 5.95371 6.10975 6.12376 5.85516C6.29381 5.60056 6.53554 5.40212 6.81838 5.28491C7.10122 5.1677 7.41247 5.13701 7.71276 5.1967C8.01304 5.25639 8.28889 5.40379 8.5054 5.62026C8.72191 5.83673 8.86936 6.11254 8.92912 6.41282C8.98887 6.71309 8.95823 7.02434 8.84108 7.30721C8.72393 7.59007 8.52553 7.83184 8.27097 8.00194C8.01641 8.17205 7.71712 8.26284 7.41096 8.26284V10.0759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.41115 12.7422C7.73292 12.7422 8.04115 12.4592 8.02638 12.127C8.01162 11.7947 7.75599 11.5117 7.41115 11.5117C7.08939 11.5117 6.78115 11.7947 6.79592 12.127C6.81069 12.4592 7.06631 12.7422 7.41115 12.7422Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.20a5c0eefc77b10a9841a8b610397985.svg";
export { ForwardRef as ReactComponent };